import React, { useEffect, useRef } from "react";

export default function ActivityChart({ data, hideLabels = false }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!window.Chart) return;

    const Chart = window.Chart;

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "doughnut",
      data: {
        labels: !hideLabels && data?.labels,
        datasets: [
          {
            data: data?.values,
            backgroundColor: data?.colors,
          },
        ],
      },
      options: {
        cutout: "70%",
        plugins: {
          legend: { position: "bottom" },
        },
      },
    });

    return () => chartInstance.current?.destroy();
  }, [data]);

  return <canvas ref={chartRef} width="230" height="230"></canvas>;
}
